import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Sparkles, SlidersHorizontal, Settings as SettingsIcon } from "lucide-react";

// Fixed bottom tab bar for signed-in users on mobile only.
// Desktop keeps the header CTA + avatar-menu pattern.
const BottomNav = ({ onOpenSettings }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const goDashboard = () => {
    if (location.pathname !== "/dashboard") {
      navigate("/dashboard");
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const goOptimizer = () => {
    const scrollToOpt = () => {
      const el = document.getElementById("optimizer");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };
    if (location.pathname !== "/dashboard") {
      navigate("/dashboard");
      // Wait for dashboard to mount, then scroll
      window.setTimeout(scrollToOpt, 350);
    } else {
      scrollToOpt();
    }
  };

  const goSimulator = () => navigate("/simulator");

  const openSettings = () => {
    if (location.pathname !== "/dashboard") {
      navigate("/dashboard", { state: { openSettings: true } });
    } else if (onOpenSettings) {
      onOpenSettings();
    }
  };

  const isDashActive = location.pathname === "/dashboard";
  const isSimActive = location.pathname === "/simulator";

  const items = [
    { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, onClick: goDashboard, active: isDashActive },
    { id: "optimizer", label: "Optimizer", icon: Sparkles, onClick: goOptimizer, active: false },
    { id: "simulator", label: "Simulator", icon: SlidersHorizontal, onClick: goSimulator, active: isSimActive },
    { id: "settings", label: "Settings", icon: SettingsIcon, onClick: openSettings, active: false },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10 bg-[#060B19]/95 backdrop-blur-xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="mx-auto max-w-lg grid grid-cols-4">
        {items.map(({ id, label, icon: Icon, onClick, active }) => (
          <button
            key={id}
            type="button"
            onClick={onClick}
            data-testid={`bottom-nav-${id}`}
            className={`flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] font-medium transition-colors ${
              active ? "text-[#00E676]" : "text-slate-400 hover:text-white"
            }`}
          >
            <Icon size={20} strokeWidth={active ? 2.2 : 1.7} />
            <span className="tracking-wide">{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
